import React, { Component } from 'react';

import { StyleSheet, css } from 'aphrodite';
import { EmptyMsgView } from '../components/EmptyMsgView';

export class NotFound extends Component {
  render() {
    return <EmptyMsgView/>
  }
}

const Styles = StyleSheet.create({
  nfMiddle: {
    fontSize: 20,
    paddingTop: '15%',
    textAlign: 'center'
  }
})


// WEBPACK FOOTER //
// ./src/screens/NotFound.js